// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Selected_wrapper__1xS6o","overlay":"Selected_overlay__21TAM","show":"Selected_show__180TQ","content":"Selected_content__2ybI6"};